<div class="table-wrapper">
  <div class="table-container">
    <table class="crud-table">
      <thead>
        <tr>
          <th>{{ "CRUD.NAME" | translate }}</th>
          <th>{{ "CRUD.SLT_STATUS" | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let mt of meterTypes"
          data-bs-toggle="modal" data-bs-target="#editAddModal"
          (click)="selectMeterType(mt)">
          <td>{{ mt.name | hasValue}}</td>
          <td>{{ mt.currentSltStatuses | hasValue}}</td>
          <td class="d-flex icons-col">
            <div>
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.50536 4.73283C6.50536 4.33333 6.82911 4.00931 7.2286 4.00931C7.6281 4.00931 7.95185 4.33333 7.95185 4.73283V7.76471L9.95724 8.64627C10.3226 8.80705 10.4883 9.23334 10.3275 9.59838C10.1667 9.96342 9.74041 10.1291 9.37537 9.96862L6.97458 8.91315C6.70032 8.81034 6.50536 8.54592 6.50536 8.23584V4.73283ZM0.897691 4.94447C0.876909 4.88294 0.864058 4.81759 0.860503 4.74951L0.751128 2.74001C0.73062 2.34216 1.03687 2.00309 1.43472 1.98286C1.83258 1.96235 2.17164 2.2686 2.19187 2.66645L2.21211 3.03833C2.5101 2.65486 2.84745 2.30367 3.21863 1.99051C3.71 1.57598 4.26809 1.22243 4.88688 0.946527C6.6552 0.157658 8.57419 0.159572 10.2468 0.800238C11.9025 1.43461 13.3192 2.69434 14.1132 4.43232C14.1343 4.47005 14.1521 4.50997 14.1663 4.55154C14.9281 6.30318 14.9191 8.19729 14.2858 9.85104C13.6514 11.5067 12.3917 12.9234 10.6537 13.7172C10.546 13.7775 10.4246 13.8091 10.3012 13.8088C9.90174 13.8088 9.57798 13.485 9.57798 13.0855C9.57798 12.7711 9.77869 12.5037 10.059 12.4041C10.2692 12.3076 10.4708 12.1999 10.663 12.0815C10.6849 12.0634 10.7081 12.0465 10.7327 12.0306C11.0425 11.8305 11.337 11.6013 11.6033 11.3459C11.6208 11.3292 11.6392 11.3134 11.658 11.2989C12.223 10.7383 12.6555 10.0668 12.9353 9.3367C13.4455 8.00506 13.4485 6.48037 12.8231 5.07872C12.1978 3.67708 11.0622 2.66016 9.73248 2.15075C8.40083 1.64079 6.87614 1.63778 5.4745 2.26286C4.99658 2.47575 4.55105 2.75494 4.15106 3.0922C3.88145 3.3197 3.63699 3.56962 3.41961 3.83841L3.51395 3.82665C3.91016 3.77825 4.27082 4.06044 4.31922 4.45665C4.36762 4.85286 4.08543 5.21353 3.68922 5.26193L1.69148 5.50802C1.31797 5.55341 0.976167 5.3054 0.897691 4.94447ZM8.50173 14.3223C9.07267 14.2583 9.34502 13.5859 8.97916 13.1421C8.82302 12.9527 8.58568 12.8594 8.34232 12.8846C7.91685 12.9324 7.4911 12.9316 7.06591 12.881C6.81052 12.8507 6.56141 12.9554 6.40446 13.1591C6.06649 13.6084 6.33473 14.2466 6.89173 14.3171C7.42712 14.3811 7.96579 14.3825 8.50173 14.3223ZM3.88774 13.2102C4.1043 13.3541 4.37364 13.3705 4.60743 13.2578C5.10754 13.0101 5.15348 12.3169 4.68973 12.0066C4.33946 11.7755 4.00231 11.4881 3.71602 11.1819C3.45406 10.903 3.02477 10.8742 2.72863 11.1165C2.65215 11.1792 2.58935 11.2569 2.54411 11.3449C2.49887 11.4328 2.47216 11.5291 2.46562 11.6278C2.45909 11.7264 2.47287 11.8254 2.50611 11.9186C2.53936 12.0117 2.59136 12.097 2.65891 12.1692C3.02367 12.5575 3.44258 12.9168 3.88774 13.2102ZM1.0489 9.41327C1.12875 9.67139 1.34203 9.85952 1.60699 9.91038C2.14129 10.0096 2.59164 9.50459 2.43086 8.98561C2.30344 8.57545 2.22605 8.15819 2.19461 7.72971C2.15742 7.2285 1.64199 6.91978 1.18125 7.11912C0.900425 7.24627 0.731167 7.52354 0.751675 7.83197C0.790503 8.36955 0.888941 8.89838 1.0489 9.41327Z"
                  fill="#17171A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="15"
                data-bs-toggle="modal"
                data-bs-target="#deleteMeterType"
                height="15"
                (click)="$event.stopPropagation(); onDeleteMeterType(mt)"
                viewBox="0 0 22 22"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z"
                  fill="#17171A"
                />
              </svg>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination">
      <app-asset-list-pagination
        [pageFromList]="currentPage"
        (pageChanged)="onPageChange($event)"
        [totalItems]="count"
      >
      </app-asset-list-pagination>
    </div>
  </div>
</div>


<div
  class="modal fade"
  id="editAddModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content edit-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header edit-modal-header">
        <h5 class="modal-title" id="meterTypeModalTitle">
          {{ (isEditMode ? "CRUD.METER_TYPE.EDIT_METER_TYPE" : "CRUD.METER_TYPE.NEW_METER_TYPE") | translate }}
        </h5>
      </div>
      <div class="modal-body edit-modal-body">
        <div>
          <span>{{ "CRUD.NAME" | translate }}</span>
          <label for="nameInput">
            <input id="nameInput" type="text" [(ngModel)]="updatedMeterType.name" [placeholder]="'CRUD.NAME' | translate" />
          </label>
        </div>
        <app-crud-multi-select-dropdown-search
          class="slt-status-dropdown"
          [items]="sltStatuses"
          [label]="!isEditMode ? 'CRUD.METER_TYPE.SLT_STATUSES' : ''"
          [showMore]="false"
          [requireApply]="false"
          (shareCheckedList)="onSltStatusSelected($event)"
          [searchFilterActive]="true"
        >
        </app-crud-multi-select-dropdown-search>
        <label>
          <button class="show-steps" (click)="addReadingSteps($event, 1)">
            {{ "CRUD.METER_TYPE.READING_STEPS" | translate }}
          </button>
        </label>
        <ng-container *ngIf="isReadingStepsVisible">
          <div *ngIf="!updatedImageUrl" class="img-preview">
            <input hidden type="file" id="choose-file" (change)="onFileSelected($event)" accept="image/*" />
            <label for="choose-file" class="upload-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
          <div *ngIf="updatedImageUrl" id="img-preview" class="img-preview">
            <img [src]="updatedImageUrl" alt="Meter Type image" />
            <div class="img-operations">
              <span class="pointer-cursor" (click)="removeImage($event)">
                <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M8.94028 8.00012L13.1403 3.80679C13.2658 3.68125 13.3363 3.51099 13.3363 3.33346C13.3363 3.15592 13.2658 2.98566 13.1403 2.86012C13.0147 2.73459 12.8445 2.66406 12.667 2.66406C12.4894 2.66406 12.3192 2.73459 12.1936 2.86012L8.00028 7.06012L3.80695 2.86012C3.68142 2.73459 3.51115 2.66406 3.33362 2.66406C3.15608 2.66406 2.98582 2.73459 2.86028 2.86012C2.73475 2.98566 2.66422 3.15592 2.66422 3.33346C2.66422 3.51099 2.73475 3.68125 2.86028 3.80679L7.06028 8.00012L2.86028 12.1935C2.7978 12.2554 2.7482 12.3292 2.71436 12.4104C2.68051 12.4916 2.66309 12.5788 2.66309 12.6668C2.66309 12.7548 2.68051 12.8419 2.71436 12.9232C2.7482 13.0044 2.7978 13.0781 2.86028 13.1401C2.92226 13.2026 2.99599 13.2522 3.07723 13.2861C3.15847 13.3199 3.24561 13.3373 3.33362 13.3373C3.42163 13.3373 3.50876 13.3199 3.59 13.2861C3.67124 13.2522 3.74498 13.2026 3.80695 13.1401L8.00028 8.94012L12.1936 13.1401C12.2556 13.2026 12.3293 13.2522 12.4106 13.2861C12.4918 13.3199 12.5789 13.3373 12.667 13.3373C12.755 13.3373 12.8421 13.3199 12.9233 13.2861C13.0046 13.2522 13.0783 13.2026 13.1403 13.1401C13.2028 13.0781 13.2524 13.0044 13.2862 12.9232C13.3201 12.8419 13.3375 12.7548 13.3375 12.6668C13.3375 12.5788 13.3201 12.4916 13.2862 12.4104C13.2524 12.3292 13.2028 12.2554 13.1403 12.1935L8.94028 8.00012Z"
                      fill="#14213D" />

                </svg>
              </span>
              <span>
                <input hidden type="file" id="choose-file" (change)="onFileSelected($event)" accept="image/*" />
                <label for="choose-file" class="pointer-cursor">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M12 15.9861C11.4477 15.9861 11 15.5384 11 14.9861V7.82854L7.75748 11.0711L6.34326 9.65685L12.0001 4L17.657 9.65685L16.2428 11.0711L13 7.82831V14.9861C13 15.5384 12.5523 15.9861 12 15.9861ZM6 14H4V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V14H18V18H6V14Z"
                        fill="black" />
                  </svg>
                </label>
              </span>
            </div>
          </div>
          <div class="reading-step" *ngFor="let step of updatedReadingSteps; let i = index">
            <div class="row step">
              <div class="col-11 input-step">
                <input
                  class="input-field-step"
                  [id]="'readingStep' + i"
                  [name]="'readingStep' + i"
                  type="text"
                  [(ngModel)]="step.description"
                  required
                  [placeholder]="'Reading Step ' + (i + 1)"
                />
              </div>
              <div class="col-1 remove-step">
                <span (click)="removeStep($event, i + 1)" class="pointer-cursor">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 17" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M8.00782 1.32324C3.95773 1.32324 0.674484 4.60649 0.674484 8.65658C0.674484 12.7067 3.95773 15.9899 8.00782 15.9899C12.0579 15.9899 15.3412 12.7067 15.3412 8.65658C15.3412 4.60649 12.0579 1.32324 8.00782 1.32324ZM5.34115 7.98991C4.97296 7.98991 4.67448 8.28839 4.67448 8.65658C4.67448 9.02477 4.97296 9.32324 5.34115 9.32324H10.6745C11.0427 9.32324 11.3412 9.02477 11.3412 8.65658C11.3412 8.28839 11.0427 7.98991 10.6745 7.98991H5.34115Z"
                        fill="#FF0000" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div class="instructions-button" *ngIf="isReadingStepsVisible && updatedReadingSteps.length > 0">
            <button (click)="addReadingSteps($event, updatedReadingSteps.length + 1)">
              {{ "COMMON.MBC_DETAILS.METER_TYPE.NEW_STEP" | translate }}
            </button>
          </div>
        </ng-container>
      </div>
      <div class="modal-footer edit-modal-footer">
        <div>
          <button class="cancel" data-bs-dismiss="modal" #closeEditModal>{{ "CRUD.CANCEL" | translate }}</button>
        </div>
        <div>
          <button class="save" (click)="save()">{{ "CRUD.SAVE" | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="deleteMeterType"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content delete-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="deleteMeterTypeTitle">
          {{ "CRUD.ARE_YOU_SURE_DELETE" | translate }} {{ "CRUD.METER_TYPE.METER_TYPE" | translate }}?
        </h5>
      </div>
      <div class="modal-footer delete-modal-footer">
        <button type="button" class="btn btn-primary" (click)="deleteMeterType()" data-bs-dismiss="modal">
          {{ "COMMON.DELETE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>



<ng-template #filterTemplate>
  <div class="crud-filter">
    <div class="filters-wrapper">
      <div class="search-bar">
        <img
          src="assets/icons/search.svg"
          alt="Search icon"
          class="search-icon"
        />
        <input
          (keydown.enter)="onSearch()"
          [(ngModel)]="searchText"
          type="text"
          class="search-input"
          [placeholder]="'COMMON.SEARCH' | translate"
        />
      </div>
    </div>
  </div>
</ng-template>
